import React from 'react';
import PropTypes from 'prop-types';

const PATHS = {
    undo: <path d="M9 14 4 9l5-5M4 9h10.5a5.5 5.5 0 0 1 0 11H11" />,
    redo: <path d="m15 14 5-5-5-5M20 9H9.5a5.5 5.5 0 0 0 0 11H13" />,
    diff: <path d="M12 3v18M5 8h4M7 6v4M15 16h4M4 21h16M4 3h16" />,
    close: <path d="M6 6l12 12M18 6 6 18" />,
    check: <path d="M5 13l4 4L19 7" />,
    info: <><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" /></>,
    alert: <><circle cx="12" cy="12" r="9" /><path d="M12 8v4M12 16h.01" /></>,
    warn: <path d="M12 9v4M12 17h.01M10.3 3.9 2.4 17.5A2 2 0 0 0 4.1 20.5h15.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />,
    trash: <path d="M4 7h16M10 11v6M14 11v6M5 7l1 13h12l1-13M9 7V4h6v3" />,
    upload: <path d="M12 16V4M7 9l5-5 5 5M4 20h16" />,
    palette: <><path d="M12 3a9 9 0 1 0 0 18c1 0 1.5-.7 1.5-1.5 0-.4-.2-.8-.4-1.1-.3-.3-.4-.7-.4-1.1 0-.8.7-1.5 1.5-1.5H16a5 5 0 0 0 5-5c0-4.4-4-7.8-9-7.8z" /><circle cx="7.5" cy="11.5" r="1" /><circle cx="10.5" cy="7.5" r="1" /><circle cx="15.5" cy="8.5" r="1" /></>,
    offline: <path d="M2 8.8a15 15 0 0 1 4.2-2.6M9 5.2A15 15 0 0 1 22 8.8M5 12.6a10 10 0 0 1 3.5-2M13 10.2a10 10 0 0 1 6 2.4M8.5 16.4a5 5 0 0 1 7 0M12 20h.01M3 3l18 18" />,
};

export default function ToastIcon({ name, className = 'toast-card__icon', spin = false }) {
    if (spin) {
        return (
            <svg className={`${className} toast-spin`} viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.5" opacity="0.25" />
                <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
            </svg>
        );
    }
    return (
        <svg
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
        >
            {PATHS[name]}
        </svg>
    );
}

ToastIcon.propTypes = {
    name: PropTypes.oneOf(Object.keys(PATHS)),
    className: PropTypes.string,
    spin: PropTypes.bool,
};
